import React, { useEffect, useState } from 'react';

import './styles.css';
import Popup from '../../../../../components/Popup';
import {FaFilter} from 'react-icons/fa';
import Input from '../../../../../components/Input';

export default function FilterPartnersPopUp(props) {
    const [name, setName] = useState("");


    function onFilter() {
        let auxArray = [...props.partners];
        if(name !== "")
            auxArray = props.partners.filter(obj => obj.nome.toLowerCase().includes(name.toLowerCase()))
        props.setPartnersToShow(auxArray);
    }

    function onResetFilters() {
        setName("");
    }

    function isReseted() {
        if(name === "")
            return true;
        else
            return false;
    }


    return (
        <Popup
        visibility={props.visibility}
        setVisibility={props.setVisibility}
        tittle="Filtrar"
        icon={<FaFilter/>}
        >
            <div className='partners-filter-container'>
                <Input
                label="Nome"
                type="text"
                id="partners-filter-name"
                onChange={(e) => setName(e.target.value)}
                cleanValue=""
                value={name}
                />
            </div>
            <button className="blue" onClick={() => {onFilter(); props.setVisibility(false)}}>
                Filtrar
            </button>

            {
                !isReseted() ?
                <button className="red" onClick={() => {onResetFilters()}}>
                    Resetar Filtros
                </button>
                :
                null
            }

        </Popup>

    )

}